// extracted by mini-css-extract-plugin
export var drawerPaper = "_3d-0";
export var itemImage = "_3d-1";